export default Object.freeze({
  BUTTON: 'button',
});
